import { connect } from 'react-redux';
import { AdministrationState } from '../../../../redux';
import TechnicalSupport from './TechnicalSupport';

const mapStateToProps = (state: AdministrationState) => ({
  isLoading: state.authSettings.organization.isLoading,
  failed: state.authSettings.organization.failed,
  supportUserAccess: state.authSettings.organization.support,
  license: state.organization.details.license?.current,
});
export default connect(mapStateToProps, null)(TechnicalSupport);
